import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { CallsParkingState, ParkedDialog } from './types';

const initialState: CallsParkingState = [];

const callsParkingSlice = createSlice({
	name: 'callsParking',
	initialState,
	reducers: {
		/** Добавить или обновить звонок по id */
		addParkingCall(state, action: PayloadAction<ParkedDialog>) {
			const newCallPark = action.payload;
			const index = state.findIndex((c) => c.callId === newCallPark.callId);

			if (index === -1) {
				state.push(newCallPark); // add
			} else {
				state[index] = newCallPark; // update
			}
		},

		/** Удалить звонок */
		removeParkingCall(state, action: PayloadAction<string>) {
			return state.filter((c) => c.id !== action.payload);
		},

		/** Очистить историю полностью */
		clearParkingCalls() {
			return [];
		},
	},
});

export const { addParkingCall, removeParkingCall, clearParkingCalls } = callsParkingSlice.actions;

export const callsParkingReducer = callsParkingSlice.reducer;
